var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InsightDisplay',{attrs:{"insight":_vm.data,"compact":_vm.compact},scopedSlots:_vm._u([{key:"thumbnail",fn:function(){return [_c('FamiliesDonut',{attrs:{"data":_vm.data,"size":_vm.size}})]},proxy:true},{key:"description",fn:function(){return [_c('FamiliesDescription',{attrs:{"data":_vm.data,"compact":_vm.compact}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }